import { render, staticRenderFns } from "./pricingTabItem.vue?vue&type=template&id=dd42bddc&scoped=true"
import script from "./pricingTabItem.vue?vue&type=script&lang=js"
export * from "./pricingTabItem.vue?vue&type=script&lang=js"
import style0 from "./pricingTabItem.vue?vue&type=style&index=0&id=dd42bddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd42bddc",
  null
  
)

export default component.exports